<section class="header">
  <h1><b title="{$version}">PATH<sup>&reg;</sup></b> - <b>P</b>rojects <b>A</b>ctivities <b>T</b>ime <b>H</b>arvest</h1>
  <h3>Stay <span>focused</span> by choosing one the quadrants below.</h3>
  <ul>
    <li><a href="/projects/work">Work</a></li>
    <li><a href="/projects/family">Family</a></li>
    <li><a href="/projects/friends">Friends</a></li>
    <li><a href="/projects/self">Self</a></li>
  </ul>
</section>

<script>
  export default {
    data() {
      return {};
    },
  }
</script>

<style>.header {
  margin-top: 30px; }

h3 {
  color: var(--gray);
  font-weight: 400;
  padding: 10px 0 20px 0; }
  h3 span {
    color: var(--secondary);
    font-weight: bold; }

ul {
  display: flex; }

li {
  margin-right: 20px; }

a {
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  background-color: var(--primary);
  border-color: var(--primary);
  border-radius: 0.375rem;
  border: 1px solid transparent;
  box-shadow: none;
  color: var(--white);
  display: inline-block;
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.125;
  padding: 0.75rem 1.25rem;
  text-align: center;
  transition: all 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06);
  user-select: none;
  vertical-align: middle;
  white-space: nowrap; }
  a:hover {
    cursor: pointer; }
  a:focus {
    box-shadow: none; }
  a:not([disabled]):not(.disabled):active {
    background-image: none;
    box-shadow: none; }

/*# sourceMappingURL=HomeHeader.html.css.map */</style>
